<app-content-header [hideBreadcrumb]="true" [class]="'py-3'" [hasBgImage]="true" [target]="'timetable'">
</app-content-header>


<div fxLayout="row" class="p-2">
    <div fxFlex="100" class="p-2">
        <mat-card>
            <mat-form-field fxFlex="25" class="pr-2 pl-2">
                <mat-select [placeholder]="translate.instant('teacher')" [(ngModel)]="selectedTeacher"
                    (selectionChange)="handleTeacherChange()">
                    <mat-option *ngFor="let teacher of teachers" [value]="teacher.id">
                        {{teacher.first_name}} {{teacher.last_name}}</mat-option>
                </mat-select>


            </mat-form-field>
            <mat-form-field fxFlex="20" class="pr-2 pl-2">
                <mat-select [placeholder]="translate.instant('semestre')" [(ngModel)]="selectedSemestre"
                    (selectionChange)="handleTeacherChange()">
                    <mat-option *ngFor="let sem of semestres_trimestres" [value]="sem.id">
                        {{sem.abbreviation}}</mat-option>
                </mat-select>


            </mat-form-field>
             <mat-icon class="success" (click)="openAvailabilityDialog()">date_range</mat-icon>
              <button mat-raised-button color="basic" class="ums_basic_button" *ngIf="selectedSemestre && selectedTeacher"
                    [style.float]="'inverse_float' | translate" >
                    <a href="/print_teacher/{{selectedTeacher}}/{{selectedSemestre}}" target="_blank" style="color: unset;
                    text-decoration: none;">  <mat-icon class="fs20">print</mat-icon> {{'buttons.print' | translate}} </a>
                </button>
        </mat-card>
        <mat-card>
            <mat-card-content>
                <table class="table" *ngIf="timetable && timetable.length > 0 ; else no_data">
                    <tr style="margin-bottom: 1px!important;">
                        <td fxFlex="6" class="bg-dark"></td>
                        <td fxFlex="{{width}}" *ngFor="let period of periods ; let index = index"
                            class="{{index % 2 == 0 ? 'bg-dark2' : 'bg-dark' }}">
                            {{period.start_hour}} - {{period.end_hour}}
                        </td>

                    </tr>
                    <tr *ngFor="let day of timetable; let index = index"
                        [style.background]="index % 2 == 0 ? '#f3f3f3' : ''">
                        <td fxFlex="6" style="margin-bottom: 1px;" class="{{index % 2 == 0 ? 'bg-dark2' : 'bg-dark' }}">
                            {{day.abbreviation}}</td>


                        <td fxFlex="{{width}}" *ngFor="let period of day.days ; let p_i = index" class="bag">
                            <span data-name="seance">
                                <ng-container *ngIf="period.seances && period.seances.length > 0">
                                   
                                <mat-card *ngFor="let seance of period.seances"
                                   
                                    [class.bg-c]="seance.subject_type && seance.subject_type.abbreviation =='C'"
                                    [class.bg-tp]="seance.subject_type && seance.subject_type.abbreviation =='TP'"
                                    [class.bg-td]="seance.subject_type && seance.subject_type.abbreviation =='TD'"
                                    [style.background]="seance.group_tp ? colors[seance.group_tp.abbreviation.substring(seance.group_tp.abbreviation.length -1)] :''"
                                    [style.margin-left.px]="seance.period && seance.start_hour != seance.period.start_hour ? getDiff(seance.start_hour , seance.period.start_hour) : 0"
                                    [style.margin-right.px]="seance.period && seance.end_hour != seance.period.end_hour ? getDiff(seance.period.end_hour , seance.end_hour) : 0"
                                    
                                    [class.bg-extra]="seance.type && seance.type =='extra_session'"
                                    [class.bg-exceptional]="seance.type && seance.type =='exceptional_session'"
                                    
                                    
                                    >
                                    <span id="{{seance.id}}">
                                        <span 
                                            style="font-size: 14px; text-transform:uppercase  !important; font-weight: bold;">
                                            {{seance.subject && seance.subject.display_name ? seance.subject.display_name : seance.subject.abbreviation}}
                                        </span>
                                        <br>
                                        <span style="font-size: 14px; text-transform:uppercase  !important;">
                                            {{seance.classroom ? seance.classroom.abbreviation : 'Pas Salle'}} |
                                            {{seance.week_name}}
                                        </span>
                                        <span style="font-size:small;">
                                            <br>{{seance.teacher?.first_name}}
                                            {{seance.teacher?.last_name}}<br>

                                        </span>
                                        <span style="font-size:small;" *ngIf="seance.type && seance.type !='session'">
                                           {{seance.start_date | date:'dd-MM-yyy'}}
                                          
                                        </span>
                                        
                                    </span>
                                    <div [class.bg-c1]="seance.subject_type && seance.subject_type.abbreviation =='C'"
                                        class="draggable p5"
                                        [class.bg-tp1]="seance.subject_type && seance.subject_type.abbreviation =='TP'"
                                        [class.bg-td1]="seance.subject_type && seance.subject_type.abbreviation =='TD'"
                                        class="top-right">
                                        {{seance.subject_type.abbreviation}}
                                    </div>
                                   
                                    <div  class="top-bottom">
                                        {{ seance.section?.abbreviation}} - 
                                        {{ seance.group_td?.abbreviation}}
                                        {{seance.group_tp?.abbreviation}}
                                    </div>
                                </mat-card>
                                </ng-container>
                            </span>
                        </td>
                    </tr>
                </table>
               <ng-template #no_data>
                    <div class="empty_frame">
                        <img src="assets/empty.png">
                    </div>
                </ng-template>
            </mat-card-content>
        </mat-card>
    </div>

</div>